import React from 'react';
import { observer } from 'mobx-react';
import { UniqueJoiningLinkChildConnectionVM } from './unique-joining-link-child-connection.viewmodel';
import { FORM_CONFIG, UJLFieldKey } from './unique-joining-link-child-connection.config';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { ConnectionTypeField } from '../../connections-list/_connection-form/connection-form-body/common-fields/connection-type.field';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';

export const UniqueJoiningLinkChildConnectionPresentation = observer((props: {vm: UniqueJoiningLinkChildConnectionVM}) => {
    const { vm } = props;

    const {
        attendeeId,
        connectionLink,
        connectionId,
        connectionPassword,
        meetingInvitation
    } = vm.getFormFields(UJLFieldKey);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form'>
                    <div className='oe-form__body'>
                        <ConnectionTypeField value={vm.type} />
                        <FormFieldInput.Text
                            field={attendeeId}
                            labelDescriptor={FORM_CONFIG[UJLFieldKey.ATTENDEE_ID].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={connectionLink}
                            labelDescriptor={FORM_CONFIG[UJLFieldKey.CONNECTION_LINK].labelDescriptor}
                            withError
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={connectionId}
                            labelDescriptor={FORM_CONFIG[UJLFieldKey.CONNECTION_ID].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={connectionPassword}
                            labelDescriptor={FORM_CONFIG[UJLFieldKey.CONNECTION_PASSWORD].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Textarea
                            field={meetingInvitation}
                            labelDescriptor={FORM_CONFIG[UJLFieldKey.MEETING_INVITATION].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                    </div>
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.updateChildConnection.bind(vm)}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />
    );
});